import React from 'react'
import './style.scss'

const PartTitle: React.FC = ({ children }) => {
  return <div className="part-title">{children}</div>
}

export default PartTitle
